import { getCurrentInstance, computed } from 'vue'

export function useAppStore() {
  const { proxy } = getCurrentInstance()
  const store = proxy.$store

  return {

    // State
    userData: computed(() => store.userData ?? { email: 'email@domain.com',
                                                  avatar: null,
                                                  first_name: ''} ),
    isOnline: computed(() => store.isOnline),
    drawer: computed(() => store.drawer),
    appName: computed(() => store.appName),
    version: computed(() => store.version),
    
    // Actions/Mutations
    setDrawer: (value) => store.drawer = value,
    setUserData: (data) => store.userData = data,
    
    // Raw store za ostale slučajeve
    store
  }
}